<div class="container-page">
  <div class="container-header">
    <img src="assets/images/logos/nexus-d.png" alt="Logo" class="logo" />
  </div>

  @if (status === '1') {
  <div class="container-card p-card justify-content-center">
    <img src="assets/images/banner/finalista.png" style="max-width: 200px" alt="Logo" class="logo" />

    <h2 class="mt-3" style="color: #333; font-weight: 600; font-size: 2rem">¡Registro completado!</h2>

    <p class="p-text-secondary p-mb-4" style="font-size: 1.1rem; max-width: 450px">
      Hemos finalizado todo el proceso y no necesitas realizar más acciones. Gracias por completar esta información, seguimos avanzando y
      muy pronto te contaremos los próximos pasos. Puedes cerrar esta página con tranquilidad.
    </p>
  </div>
  }

  @if (status === '2') {
  <div class="container-card p-card justify-content-center">
    <img src="assets/images/banner/requisicion_cerrada.png" style="max-width: 200px" alt="Logo" class="logo" />

    <h2 class="mt-3" style="color: #333; font-weight: 600; font-size: 2rem">¡Requisición cerrada!</h2>

    <p class="p-text-secondary p-mb-4" style="font-size: 1.1rem; max-width: 450px">
      Esta requisición se encuentra cerrada, por lo que no es posible ingresar nueva información. Gracias por tu interés y compromiso durante el proceso.
    </p>
  </div>
  }

  <div class="container-footer">
    <span class="text-xs">© 2025 Misión Empresarial. Todos los derechos reservados.</span>
  </div>
</div>
